import { render } from "./App.vue?vue&type=template&id=4a4b1a65"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4a4b1a65&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__